import { useCurrentAccess } from '#hooks/useCurrentAccess';
import { useSelector } from '#redux';

/** Ruta de Gavi inteligente (solo admin, desde la brújula de Inicio). */
export const RUTA_GAVI = '/gavi';

/**
 * Gavi inteligente solo mira presupuestos tuyos (Vadik, 31-oct-2026): uno
 * solo en este móvil, o uno en la nube del que eres dueño, aunque otras
 * personas lo vean (p. ej. en «Solo ver»). Los antiguos sin dueño apuntado
 * son del admin, como en el servidor (#132). Un presupuesto de otra persona,
 * nunca.
 */
export function presupuestoPropio({
  cloudFileId,
  dueno,
  miId,
  esAdmin,
}: {
  cloudFileId: string | null | undefined;
  /** Dueño del presupuesto en la nube; undefined si no está en la lista. */
  dueno: string | null | undefined;
  miId: string | null | undefined;
  esAdmin: boolean;
}): boolean {
  if (!cloudFileId) {
    return true;
  }
  if (dueno === undefined) {
    return false;
  }
  if (!dueno) {
    return esAdmin;
  }
  return Boolean(miId) && dueno === miId;
}

/** ¿Se puede abrir Gavi inteligente con el presupuesto abierto? */
export function useGaviInteligente(): boolean {
  const { cloudFileId, isAdmin } = useCurrentAccess();
  const allFiles = useSelector(state => state.budgetfiles.allFiles || []);
  const userData = useSelector(state => state.user.data);
  const archivo = cloudFileId
    ? allFiles.find(f => 'cloudFileId' in f && f.cloudFileId === cloudFileId)
    : undefined;
  const dueno =
    archivo && 'owner' in archivo ? (archivo.owner ?? null) : undefined;
  const miId = userData && 'userId' in userData ? userData.userId : null;
  return (
    isAdmin && presupuestoPropio({ cloudFileId, dueno, miId, esAdmin: isAdmin })
  );
}
